var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.2 190.5",
    style: {
      enableBackground: "new 0 0 188.2 190.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D7D7D7;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E5274C;}\n\t.st3{opacity:0.16;fill:#202020;enable-background:new    ;}\n\t.st4{fill:#FFFFFF;stroke:#D6D7D7;stroke-miterlimit:10;}\n\t.st5{fill:#1F1F1F;}\n\t.st6{fill:none;stroke:#1F1F1F;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#EEC72F;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:#EEC72F;}\n\t.st9{fill:#F07089;}\n\t.st10{opacity:0.12;fill:#202020;enable-background:new    ;}\n\t.st11{fill:none;stroke:#F07089;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st12{fill:#D6D7D7;}\n\t.st13{fill:#1F2020;}\n\t.st14{fill:#534A5D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6445",
    className: "st0",
    d: "M183.1,119.8c-10.3,38.6-39.4,69.4-100.3,69.6C6.9,189.6,0.8,136.2,0,84.5 C-0.9,24.7,85.7,6,132.9,0.4C184.2-5.8,196.5,69.5,183.1,119.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8149",
    transform: "translate(7.353 17.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6446",
    className: "st1",
    d: "M78.7,172.6c28.6-0.1,50.7-6.4,67.5-16.9c-9.4-31.6-29.1-28.5-52-28.5 c-24.7,0-47.9,0-55.5,39.4C49.6,170.5,62.7,172.6,78.7,172.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8142",
    transform: "translate(49.572 25.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6447",
    className: "st1",
    d: "M6,0.7c6.6-6.1,17.3-5.3,24,1.8s7.3,15.2-6.7,17.1C14.3,20.8,11,29.9,6.1,24.7 C-0.6,17.6-0.6,6.8,6,0.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6448",
    className: "st0",
    d: "M26.3,12.6c3.7,4.7-4.7,2.4-9.4,6.1s-4.4,6-6.6,2.7c-3.4-4.9-3.7-9.6,1-13.3 S22.6,7.9,26.3,12.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8143",
    transform: "translate(0.578 87.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6449",
    className: "st1",
    d: "M2.4,15.8C-0.8,9,2.1,1,8.8-2.2c6.7-3.2,14.8-0.3,17.9,6.5c4,8.9,12.5,14.9,22.2,15.6 l-0.2,0l-0.3,27C47.1,46.8,16.6,46,2.4,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6450",
    className: "st2",
    d: "M44.2,16.4L58.5,21c9.2,3,14.4,12.3,11.6,20.7l-0.8,2.5C66.4,52.7,56.8,57,47.6,54 l-14.2-4.7L44.2,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6451",
    className: "st3",
    d: "M44.2,16.4L58.5,21c9.2,3,14.4,12.3,11.6,20.7l-0.8,2.5C66.4,52.7,56.8,57,47.6,54 l-14.2-4.7L44.2,16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6452",
    className: "st2",
    d: "M60.5,115.8c-9.7,10.2-17.1,22.3-21.7,35.6c0,0,54.4,25.8,114.7,0c0,0-14.4-31.9-24-38.2 C129.4,113.2,95.8,88.3,60.5,115.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_854",
    className: "st1",
    cx: 99.5,
    cy: 73.1,
    r: 52.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_855",
    className: "st4",
    cx: 77,
    cy: 94.7,
    r: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_856",
    className: "st5",
    cx: 71.4,
    cy: 88,
    r: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6453",
    className: "st6",
    d: "M63.7,104.5c4.3,4.4,11.1,5,16.2,1.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8144",
    transform: "translate(65.154 65.363)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_857",
    className: "st5",
    cx: 4.7,
    cy: 0.1,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_858",
    className: "st5",
    cx: 33.5,
    cy: 4.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6454",
    className: "st2",
    d: "M64.4,114.1c0,0,28.6,15.3,71.4-3.1l-5.8,33.2C130,144.3,59.1,162.8,64.4,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6455",
    className: "st7",
    d: "M105.5,36.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6456",
    className: "st7",
    d: "M77,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6457",
    className: "st8",
    d: "M102.2,38.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8145",
    transform: "translate(58.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6458",
    className: "st9",
    d: "M14.5,29.2c0,0-26.2,11.7-5.5,19c0,0,24.5,10.1,40,3.1c0,0,15.4-6.4,26.4-12.7 c1.5-0.8,2.1-2.7,1.3-4.2c-0.4-0.8-1.2-1.4-2.1-1.6C61.7,29.3,27.3,22.1,14.5,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6459",
    className: "st2",
    d: "M74.2,30.8c0,0.5-13.7,8.3-32.3,6.3c-17.6-1.9-27.5-7.2-27.5-10 c0.1-18.9,10.1-26.5,31.4-25C63.9,3.3,74.6,4.9,74.2,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6460",
    className: "st2",
    d: "M14.5,27.1c0,0-12.8,5.3-13.3,11.2c-0.2,2.5,1.8,5.2,7.9,7.6c0,0,22.9,10.6,39.9,3.3 c0,0,15.5-6.4,26.5-12.7c2.5-1.5,1.6-5-1.3-5.8C61.2,27.3,27.3,20.1,14.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6461",
    className: "st10",
    d: "M23.6,6.1c1.1-0.7,2.2-1.3,3.4-1.8c0,0-5.8,2.6-6.8,27.5l-2.2-1.5 C17.9,30.3,16.2,19.3,23.6,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6462",
    className: "st11",
    d: "M41.4,37.1c0,0,19.1,2.8,32.4-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6463",
    className: "st11",
    d: "M14.9,27.8c1.4,1.7,3.2,3,5.2,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6464",
    className: "st2",
    d: "M63.3,5.1c0,0-22.6,0.1-21.4,32.1c-0.6,0.4-1.2,0.6-1.9,0.5c-13.2,0.9-20-4.6-19.9-5 c0,0-2.1-32.9,16.4-36.1C36.6-3.4,62.4-4.8,63.3,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6465",
    className: "st9",
    d: "M63.1,3.8c0,0-23.4-3.4-23,33.8c0,0,1.5,0,1.9-0.5c0,0-2.7-30.2,21.4-32.1L63.1,3.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_859",
    className: "st12",
    cx: 30.1,
    cy: 22.1,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_860",
    className: "st1",
    cx: 28.2,
    cy: 22,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6466",
    className: "st13",
    d: "M23.1,15.3l0.3,0c0.3,0,0.8,0.1,1.5,0.2c0.4,0,0.7,0,1,0s0.6,0,1,0 c3.1,0.2,4.9,1.7,4.7,3.8c-0.2,1.5-1.2,2.7-2.6,3.2l-0.2,0.1l0,0l0,0c0.6,1.3,1.4,2.5,2.3,3.6c0.7,0.8,1.5,1.5,2.6,1.8 c0.2,0,0.3,0.2,0.3,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.4,0.2-1.2,0.1c-2.9-0.2-4.1-2.6-5.1-4.6c-0.1-0.2-0.2-0.4-0.3-0.6l0,0 c-0.2-0.4-0.5-0.6-0.9-0.8l-0.1,0c-0.2-0.1-0.4-0.3-0.4-0.5c0-0.2,0.2-0.4,0.4-0.3c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 c0.2,0,0.3,0.1,0.5,0.1c0.7,0.1,1.4-0.1,2-0.6c0.5-0.4,0.8-1,0.9-1.7c0.1-1.8-1.1-3-3.2-3.1c-0.7,0-0.7,0-0.7,0.2l-0.7,8.5 c-0.1,1.4,0.5,1.6,1.1,1.7c0.3,0.1,0.6,0.2,0.6,0.5c0,0.4-0.6,0.4-0.8,0.4c-0.3,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-1.2-0.1 c-0.5,0-0.8,0-1.2-0.1c-0.3,0-0.5,0-0.7,0c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0c0-0.3,0.3-0.4,0.6-0.4c0.4-0.1,0.9-0.2,1-1.3 l0.6-8.1c0.1-1.1-0.3-1.1-0.7-1.2c-0.2,0-0.6-0.1-0.6-0.5C22.6,15.4,22.8,15.3,23.1,15.3C23.1,15.3,23.1,15.3,23.1,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6467",
    className: "st11",
    d: "M20.1,32.7c0,0,5.3,5.4,19.9,4.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8146",
    transform: "translate(59.335 119.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6468",
    className: "st2",
    d: "M48.5,14.1l9.8-11.3c6.4-7.3,16.9-8.5,23.6-2.7l2,1.7c6.6,5.8,6.9,16.4,0.5,23.7L74.6,37 L48.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6469",
    className: "st14",
    d: "M16.2,13.7L7,7.4C6.5,7.1,5.8,7.1,5.3,7.6l-3.9,4.1c-0.4,0.5-0.5,1.2-0.1,1.7l6.8,8.9 c0.4,0.6,1.3,0.7,1.8,0.2c0.1,0,0.1-0.1,0.2-0.1l1.1-1.1l17.9,17l4-4.3L15.2,17l1.2-1.3c0.5-0.5,0.5-1.4,0-1.9 C16.3,13.8,16.3,13.7,16.2,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6470",
    className: "st1",
    d: "M31.7,52.5c-7.4,0.3-13.7-5.4-14.1-12.9s5.4-13.7,12.9-14.1c0,0,0.1,0,0.1,0 c9.7-0.2,18.5-5.7,23-14.4l-0.1,0.2l24.7,10.8C77.7,23.4,65.2,51.1,31.7,52.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8148",
    transform: "translate(120.922 36.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6471",
    className: "st1",
    d: "M24.8-1.4c7.8,4.5,10,15.1,5.1,23.5s-12.5,11.4-18.3-1.5C7.9,12.4-1.7,11.8,1.8,5.7 C6.8-2.8,17.1-5.9,24.8-1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6472",
    className: "st0",
    d: "M21.1,20.1c-3.3,4.7-4-4-9.3-7.8s-7.4-2.9-5-5.8c3.6-4.4,8.1-5.8,13.4-2 S24.4,15.4,21.1,20.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6473",
    className: "st14",
    d: "M25.9,61.2c-0.4-5.2-4-9.6-9-11c-0.7-0.2-1.4,0.2-1.6,0.9c-0.1,0.3,0,0.7,0.1,1l2.4,4.1 c1.1,1.9,0.4,4.3-1.5,5.4c0,0,0,0,0,0l-4.5,2.6c-1.9,1.1-4.3,0.4-5.4-1.5l-2.4-4.3c-0.4-0.6-1.1-0.8-1.8-0.5 c-0.3,0.2-0.5,0.4-0.6,0.8c-1.7,6,1.3,12.4,7.1,14.9l2.9,38.6c0.2,3.4,3.2,5.9,6.6,5.7c0,0,0,0,0,0l0,0c3.4-0.2,5.9-3.2,5.7-6.6 c0,0,0,0,0,0l-2.9-39.1C24.3,69.6,26.2,65.4,25.9,61.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_861",
    className: "st1",
    cx: 23.3,
    cy: 101.7,
    rx: 7.1,
    ry: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOso);
export default __webpack_public_path__ + "static/media/oso.c2e964c3891e92b8e4cd5b2dfd9fb970.svg";
export { ForwardRef as ReactComponent };